'use client'

import AccordionGeneral from './AccordionGeneral'

export { AccordionGeneral }
